import { motion } from "framer-motion";
import { BRAND_STATEMENT } from "@/data/content";

export const BrandStatement = () => (
  <section
    data-testid="brand-statement-section"
    className="relative isolate overflow-hidden border-y border-border/70"
  >
    <div className="absolute inset-0 -z-10">
      <img
        src={BRAND_STATEMENT.backdrop}
        alt=""
        aria-hidden="true"
        className="h-full w-full object-cover opacity-45"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-[linear-gradient(105deg,hsl(var(--ink)/0.97),hsl(var(--navy-950)/0.85)_55%,hsl(var(--navy-800)/0.6))]" />
      <div className="absolute inset-0 bg-[radial-gradient(90%_70%_at_18%_30%,hsl(var(--aqua)/0.09),transparent)]" />
    </div>

    <div className="shell grid gap-14 py-28 lg:grid-cols-12 lg:items-end lg:py-44">
      <div className="lg:col-span-7">
        <h2 className="display text-[2.5rem] leading-[0.92] text-offwhite sm:text-6xl lg:text-[5rem]">
          {BRAND_STATEMENT.lines.map((line, i) => (
            <motion.span
              key={line}
              className="block"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            >
              {i === 2 ? <span className="text-aqua">{line}</span> : line}
            </motion.span>
          ))}
        </h2>
      </div>

      <motion.div
        className="lg:col-span-5 lg:pb-3"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, delay: 0.35 }}
      >
        <span className="block h-px w-16 bg-aqua/60" />
        <div className="mt-8 space-y-1">
          {BRAND_STATEMENT.supporting.map((line) => (
            <p key={line} className="serif-note text-xl text-offwhite/90 sm:text-2xl">
              {line}
            </p>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
